export default '¤#,##0.00;(¤#,##0.00)';